import { OtoIndividualLocalRepresentative } from '../../lib/types/models/enrollment/oto-individual-enrollments'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

// The responsable du séjour of a One to One Individuel stay: nothing comes back before LEC diffused
// the placement to the parents or while the prestataire has not recorded anyone.
export function getOtoIndividualLocalRepresentative(enrollmentId: number) {
  return restApiClient
    .url(
      constructApiUrl(API.enrollments.getOtoIndividualLocalRepresentative.url, {
        id: enrollmentId
      })
    )
    .get<OtoIndividualLocalRepresentative | null>()
}
